import { render, staticRenderFns } from "./ProductDetailsSetItems.vue?vue&type=template&id=93ce982e"
import script from "./ProductDetailsSetItems.vue?vue&type=script&lang=js"
export * from "./ProductDetailsSetItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports